<template>
<div>
    <div class="">
        <!-- Janela de Alerta de Solicitação -->
        <template v-if="primeiranota">
            <div id="dialog-doc" class="es-dialog">
                <div class="es-dialog-container">
                    <div class="es-header">Alerta de Solicitação</div>
                    <div class="es-sol-container">
                        <template v-if="primeiranota.idhotlinesolicitacoes">
                            <div>
                                <div class="timeline-panel es-azure rounded">
                                    <div class="card-header">
                                        <div class="col-md-1"></div>
                                        <h2><span class="material-icons">{{$store.getters.GetLoginInfo.icone}}</span></h2>
                                        <h3>{{primeiranota.assunto}}</h3>
                                        <div class="col-md-1"></div>
                                    </div>
                                    <div class="card-body">
                                        <h4 class="d-block es-sol-text">{{primeiranota.texto}}</h4>
                                        <h5 v-if="primeiranota.nome" class="d-block">Hóspede: <b>{{primeiranota.nome+' '+primeiranota.sobrenome}}</b></h5>
                                        <h5 class="d-block">UH: <b>{{primeiranota.coduh}}</b></h5>
                                        <h6 class="d-block">Data: {{formatarData(primeiranota.datanotificacao)}}</h6>
                                        <h6 class="d-block"><strong>#{{primeiranota.idhotlinesolicitacoes}}</strong></h6>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                        <template v-if="!primeiranota.idhotlinesolicitacoes">
                            <div class="es-table-header">
                                <div class="es-row">
                                    <div class="col-md-1"><strong>#</strong></div>
                                    <div class="col-md-1"><strong>UH</strong></div>
                                    <div class="col-md-2"><strong>Nome</strong></div>
                                    <!-- <div class="col-md-3"><strong>Texto</strong></div> -->
                                    <div class="col-md-3"><strong>Acordar às</strong></div>
                                    <div class="col-md-2"><strong>Status</strong></div>
                                    <div class="col-md-2"><strong>Atendido?</strong></div>
                                </div>
                            </div>
                            <div class="es-table-content">
                                <div v-for="(solDesp, index) in solsDesp" :key="index">
                                    <div 
                                        :class="{'es-row es-even': isEven(index), 'es-row es-odd': !isEven(index)}"
                                    >
                                        <div class="col-md-1">{{solDesp.idhotlinesolicitacoes}}</div>
                                        <div class="col-md-1">{{solDesp.coduh}}</div>
                                        <div class="col-md-2">{{solDesp.nome}} {{solDesp.sobrenome}} </div>
                                        <!-- <div class="col-md-3">{{solDesp.textohotlinesolicitacoes}}</div> -->
                                        <div class="col-md-3"><strong>{{formatarData(solDesp.datahoraagendamento,'DD/MM/YY HH:mm:ss')}}</strong></div>
                                        <div class="col-md-2">{{solDesp.status}}</div>
                                        <div class="col-md-2 text-center"
                                            :id="'solOK_'+solDesp.idhotlinesolicitacoes"
                                        >
                                            <input type="checkbox" name="input-ok" class="custom-control-input ponteiro" :id="'acordado-ok-'+solDesp.idhotlinesolicitacoes" :checked="solDesp.selected" v-model="solDesp.selected">
                                            <label :class="{'text-green': solDesp.selected, 'text-red': !solDesp.selected}" class="custom-control-label ponteiro" :for="'acordado-ok-'+solDesp.idhotlinesolicitacoes">{{solDesp.selected?'Sim':'Não'}}</label>
                                        </div>
                                        <!-- <div v-if="solDesp.selected" class="col-md-0"><strong><span class="material-icons icon text-green">check</span></strong></div> -->
                                    </div>
                                </div>                            
                            </div>
                        </template>                        
                    <div v-if="primeiranota.idhotlinesolicitacoes"
                        style="display:flex;flex-direction:row;justify-content:center;"
                    >
                        <div class="btn btn-primary mx-2" @click="fecharEVisualizar(primeiranota)">Abrir Solicitação</div>
                        <div class="btn btn-primary mx-2" @click="toggleDoc">Fechar</div>
                    </div>
                    <div v-if="!primeiranota.idhotlinesolicitacoes"
                        style="diplay:flex;flex-direction:row;justify-content:center;padding:0.25rem;"
                    >
                        <div class="btn btn-primary m-0" @click="toggleDoc">Fechar</div>
                    </div>
                </div>
            </div>
        </template>

        <!-- Janela de Help -->
        <Help :show="showHelp"
            :filtroCat="filtroCategorias"
            :initialPage="helpPage"
            @close="showHelp=false"
        ></Help>

        <!-- Cabeçalho -->
        <div class="header">
            <div class="header-content">
                <nav class="navbar navbar-expand">
                    <div class="collapse navbar-collapse justify-content-around">
                        <div class="header-left">
                            <div class="dashboard_bar">
                                {{this.$store.getters.GetCurrentItem && this.$store.getters.GetCurrentItem.name}}
                            </div>
                        </div>
                        <div class="header-center" v-if="(env === 'development')">
                            <h3>{{this.$store.getters.GetLoginInfo.hotel.nome}}</h3>
                        </div>
                        <ul class="navbar-nav header-right">
                            <!-- Notificações -->
                            <li class="nav-item dropdown notification_dropdown">
                                <a class="nav-link primary notification" href="#" role="button" data-toggle="dropdown">
                                    <svg width="22" height="22" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.75 14.8385V12.0463C21.7471 9.88552 20.9385 7.80353 19.4821 6.20735C18.0258 4.61116 16.0264 3.61555 13.875 3.41516V1.625C13.875 1.39294 13.7828 1.17038 13.6187 1.00628C13.4546 0.842187 13.2321 0.75 13 0.75C12.7679 0.75 12.5454 0.842187 12.3813 1.00628C12.2172 1.17038 12.125 1.39294 12.125 1.625V3.41534C9.97361 3.61572 7.97429 4.61131 6.51794 6.20746C5.06159 7.80361 4.25291 9.88555 4.25 12.0463V14.8383C3.26257 15.0412 2.37529 15.5784 1.73774 16.3593C1.10019 17.1401 0.751339 18.1169 0.75 19.125C0.750764 19.821 1.02757 20.4882 1.51969 20.9803C2.01181 21.4724 2.67904 21.7492 3.375 21.75H8.71346C8.91521 22.738 9.45205 23.6259 10.2331 24.2636C11.0142 24.9013 11.9916 25.2497 13 25.2497C14.0084 25.2497 14.9858 24.9013 15.7669 24.2636C16.548 23.6259 17.0848 22.738 17.2865 21.75H22.625C23.321 21.7492 23.9882 21.4724 24.4803 20.9803C24.9724 20.4882 25.2492 19.821 25.25 19.125C25.2486 18.117 24.8998 17.1402 24.2622 16.3594C23.6247 15.5786 22.7374 15.0414 21.75 14.8385ZM6 12.0463C6.00232 10.2113 6.73226 8.45223 8.02974 7.15474C9.32723 5.85726 11.0863 5.12732 12.9212 5.125H13.0788C14.9137 5.12732 16.6728 5.85726 17.9703 7.15474C19.2677 8.45223 19.9977 10.2113 20 12.0463V14.75H6V12.0463ZM13 23.5C12.4589 23.4983 11.9316 23.3292 11.4905 23.0159C11.0493 22.7026 10.716 22.2604 10.5363 21.75H15.4637C15.284 22.2604 14.9507 22.7026 14.5095 23.0159C14.0684 23.3292 13.5411 23.4983 13 23.5ZM22.625 20H3.375C3.14298 19.9999 2.9205 19.9076 2.75644 19.7436C2.59237 19.5795 2.50014 19.357 2.5 19.125C2.50076 18.429 2.77757 17.7618 3.26969 17.2697C3.76181 16.7776 4.42904 16.5008 5.125 16.5H20.875C21.571 16.5008 22.2382 16.7776 22.7303 17.2697C23.2224 17.7618 23.4992 18.429 23.5 19.125C23.4999 19.357 23.4076 19.5795 23.2436 19.7436C23.0795 19.9076 22.857 19.9999 22.625 20Z" fill="#000"></path></svg>
                                    <div id="pulse" class=""></div>
                                    <span v-if="this.$store.getters.GetNotificacoes && this.$store.getters.GetNotificacoes.length>0" 
                                        class="badge"
                                    >
                                        {{this.$store.getters.GetNotificacoes.length}}
                                    </span>
                                </a>
                                <div class="dropdown-menu dropdown-menu-right es-scroll">
                                    <div v-if="$store.getters.GetNotificacoes.length > 0" id="DZ_W_Notification1" class="widget-media dz-scroll p-3" style="maxheight:400px;">
                                        <ul class="timeline">
                                            <li v-for="nota in this.$store.getters.GetNotificacoes" :key="nota.idnotificacao">
                                                <div class="ponteiro" @click="visualizarSolicitacao(nota)">
                                                    <div class="timeline-panel">
                                                        <div class="media mr-2 media-warning">
                                                            <span class="material-icons">{{$store.getters.GetLoginInfo.icone}}</span>
                                                        </div>
                                                        <div class="media-body">
                                                            <h6 class="mb-0">{{nota.assunto}}</h6>
                                                            <small class="d-block">{{nota.texto}}</small>
                                                            <small class="d-block">Hóspede: <b>{{nota.nome+' '+nota.sobrenome}}</b></small>
                                                            <small class="d-block">Quarto: <b>{{nota.coduh}}</b></small>
                                                            <small class="d-block">{{formatarData(nota.datanotificacao)}}</small>
                                                            <small class="d-block"><strong>#{{nota.idhotlinesolicitacoes}}</strong></small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        <div v-if="this.$store.getters.GetNotificacoes && this.$store.getters.GetNotificacoes.length==0">
                                            <p>Sem notificações no momento!</p>
                                        </div>
                                    </div>
                                    <div v-if="$store.getters.GetNotificacoes.length == 0" id="DZ_W_Notification1" class="widget-media dz-scroll p-3" style="maxheight:400px;text-align:center;margin-top:20px;">
                                        <b>Sem Notificações Por Enquanto</b>
                                    </div>
                                </div>
                            </li>
                            <!-- Perfil -->
                            <li class="nav-item dropdown header-profile ml-3">
                                <div class="nav-link" data-toggle="dropdown">
                                    <a href="#" role="button" class="avatar-container">
                                        <img id="imgHeader" :src="avatar" width="20" alt=""/>
                                        <img v-if="!avatar" id="imgHeader" src="img/avatar/P0.png" width="20" alt=""/>
                                    </a>
                                </div>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a @click="logOut();" class="dropdown-item ai-icon">
                                        <svg id="icon-logout" xmlns="http://www.w3.org/2000/svg" class="text-danger" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                                        <span class="ml-2">Logout </span>
                                    </a>
                                    <a @click="$router.push('perfil');" class="dropdown-item ai-icon">
                                        <span class="material-icons">manage_accounts</span>
                                        <span class="ml-2">Perfil </span>
                                    </a>
                                </div>
                            </li>
                        </ul>
                        <div class="navbar-nav header-right">
                            <div class="es-help" @click="setFilterAndOpen()">
                                <span class="material-icons icon">help</span>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import CONSTANTS from '../constants'
import moment from "moment";
import Help from './Help.vue'

export default {
    components: {
        Help
    },
    data() {
        return {
            avatar: CONSTANTS.API_URL + (this.$store.getters.GetLoginInfo.avatar ? 
                this.$store.getters.GetLoginInfo.avatar : '/img/perfil/P0.png'
            ),
            // Token das chamadas ao backend
            headers: {
                'x-access-token': this.$store.getters.GetLoginInfo.token
            },
            notificacoes: [],
            sounds: CONSTANTS.SOUNDS,
            intervalId: 0,
            solsDesp: [],
            showHelp: false,
            filtroCategorias: `${this.$store.getters.GetCurrentItem?.helpindex}`,
            helpPage: 1,
            env: process.env.NODE_ENV
        }
    },
    computed: {
        initials() {
            var names = this.$store.getters.GetLoginInfo.nome.split(' ')
            var init1 = ''
            var init2 = ''
            if (names.length > 1) {
                init1 = names[0].substring(0,1)
                init2 = names[1].substring(0,1)
            } else {
                if (names.length > 0) {
                    init1 = names[0].substring(0,1)
                    init2 = names[0].substring(0,2)
                }
            }
            return init1+init2
        },
        primeiranota() {
            if (this.$store.getters.GetNotificacoes.length > 0) {
                return this.$store.getters.GetNotificacoes[0]
            } else {
                return null
            }
        }
    },
    methods: {
        setFilterAndOpen() {
            this.filtroCategorias = `${this.$store.getters.GetCurrentItem?.helpindex}`;
            this.helpPage = 1;
            this.showHelp = !this.showHelp;
        },
        registrarAtendimentoBulk() {
            var itens = []
            for (var i = 0; i < this.solsDesp.length; i++) {
                var umItem = this.solsDesp[i]
                if (umItem.selected) {
                    itens.push({
                        idhotlinesolicitacoes: umItem.idhotlinesolicitacoes,
                        dataatendimento: moment().format(),
                        textoatendimento: this.$t('sols.suasolicitacaofoiatendida'),
                        idusuario: this.$store.getters.GetLoginInfo.idusuario,
                        idstatus:  3,
                        alterado_por: this.$store.getters.GetLoginInfo.idusuario
                    })
                }
            }
            var params = {
                itens: itens,
				alterado_por: this.$store.getters.GetLoginInfo.idusuario
            }
            console.log(JSON.stringify(params))
            axios.post(CONSTANTS.API_URL + '/fdguest/hotlinesolicitacoes/bulk/update', params
                , {headers: this.headers}).then(response => {
                if(response.status == 200) {
                    if (itens.length == this.solsDesp.length) {
                        this.visualizarSolicitacao(this.primeiranota)
                    }
                } else {
                    console.error(JSON.stringify(response))
                }
            })
        },        
        // ticarItem(sol) {
        //     sol.selected = true;
            // var el = document.getElementById('solOK'+sol.idhotlinesolicitacoes)
            // if (el) {
            //     this.forceUpdate();
            // }
        // },
        isEven(val) {
            return (val % 2 == 0)
        },
        toggleDoc(){
            var docDialog = document.getElementById('dialog-doc')
            if (docDialog) {
                if (docDialog.style.display == 'none') {
                    docDialog.style.display = 'flex'
                } else {
                    docDialog.style.display = 'none'
                    if (!this.primeiranota.idhotlinesolicitacoes) {
                        this.registrarAtendimentoBulk();
                    }
                }
            }
        },
        logOut() {
            // liberar memória da sessão (persistedstate)
            // sessionStorage.clear();
            window.clearInterval(this.$store.getters.GetNodeIntervalId);
            this.$router.push('/');
        },
        showDoc(despertar=true) {
            var docDialog = document.getElementById('dialog-doc')
            if (docDialog) {
                if (docDialog.style.display == 'none' || docDialog.style.display == '') {
                    docDialog.style.display = 'flex'
                    this.playSound();
                    if (despertar) {
                        this.carregarSolsAcordar();
                    }
                }
            }
        },
        carregarSolsAcordar() {
            var params = {
					idhotel: this.$store.getters.GetLoginInfo.hotel.idhotel,
					idioma: this.$i18n.locale,
                    limit: this.$store.getters.GetLoginInfo.hotel.antecedencia
				}
            //console.error(`carregarSolsAcordar(): ${JSON.stringify(params)}`)
            this.solsDesp = [];
			axios.post(CONSTANTS.API_URL + '/fdguest/hotlinesolicitacoes/select/despertar', params, {headers: this.headers})
			.then(response => {
				if (response.status == 200) {
					if (response.data) {
                        //console.error(`JSON.stringify(response.data): ${JSON.stringify(response.data)}`)
                        this.solsDesp = response.data;
                        this.$forceUpdate();
					}
				} else {
					console.log(response.message)
				}
			})
			.catch((err) => {
				console.log({ err_menu: err });
			});
        },        
        playSound() {
            //var snd = new Audio("data:audio/wav;base64,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");
            var index = this.$store.getters.GetLoginInfo.hotel.somalerta
            index = index?index:0
            var snd = new Audio(this.sounds[index]['value']);
            snd.play();
        },
        loadNotificacoes() {
            const params = {
                idhotel: this.$store.getters.GetLoginInfo.hotel.idhotel,
                idioma: this.$i18n.locale,
                idusuario: this.$store.getters.GetLoginInfo.idusuario,
                tipo: 'U',
                whereRaw: 'n.datavisualizacao is null',
                orderby: "idnotificacao"
			}
            let tipo = this.$store.getters.GetLoginInfo.idusuariotipo;
            if (tipo == '3' || tipo == '4') {
                params.para = this.$store.getters.GetLoginInfo.idpessoa
            }
            
			axios.post(CONSTANTS.API_URL + '/fdguest/notificacao/select', params, {headers: {
                'x-access-token': this.$store.getters.GetLoginInfo.token
            }})
			.then(response => {
				if (response.status == 200) {
					if (response.data) {
						this.$store.dispatch('set_Notificacoes', response.data);
                        var despertarSemSols = response.data && response.data.length > 0
                            && !response.data[0]['idhotlinesolicitacoes']
                            && this.solsDesp.length==0
                        var obj = document.getElementById('pulse')
                        if (obj && !despertarSemSols) {
                            if (response.data.length == 0) {
                                if (obj.classList.contains('pulse-css')) {
                                    obj.classList.remove('pulse-css')
                                }
                            } else {
                                if (!obj.classList.contains('pulse-css')) {
                                    obj.classList.add('pulse-css')
                                }
                            }
                        }
                        if (response.data.length > 0) {
                            if (this.$route.path != '/painel/solicitacaodetalhe') {
                                this.showDoc(true)
                            }
                        }
					}
				} else {
					console.log(response.message)
				}
			})
			.catch((err) => {
                if (err.message.includes('403')) {
                    console.log('Erro de autenticação! Direcionar para login...');
                    //sessionStorage.clear();
                    window.clearInterval(this.intervalId);
                    this.$router.push('/');
                } else {
                    console.log(JSON.stringify(err))
                }
			});
        },
        formatarData(aDate, f = 'LLL') {
            return moment(aDate).locale(this.$i18n.locale).format(f);
        },
        fecharEVisualizar(primeiranota) {
            this.toggleDoc();
            this.visualizarSolicitacao(primeiranota);
        },
        visualizarSolicitacao(nota) {
            var params = {
                "idnotificacao" : nota.idnotificacao,
                "datavisualizacao" : moment().format(),
				"alterado_por": this.$store.getters.GetLoginInfo.idusuario
            };
            //console.error(`params: ${params}`)
            axios.put(CONSTANTS.API_URL + '/fdguest/notificacao/update', params, {headers: this.headers})
            .then(response => {
                if (response.status == 200) {
                    if (response.data) {
                        // Nota visualizada recarregar lista
                        this.loadNotificacoes()
                    }
                }
            }).catch((err) => {
                console.log({ err_menu: err });
            });
            if(nota.idhotlinesolicitacoes) {
                this.$store.dispatch('set_Sol_Atual', nota.idhotlinesolicitacoes);
                // console.log(this.$route)
                if (this.$route.path == '/painel/solicitacaodetalhe') {
                    window.location.reload();
                } else {
                    this.$router.push('solicitacaodetalhe')
                }
            }
            // var link = this.GetLinkSetor(nota.idhotlinesetores);
            // if (link) {
            //     this.$router.push(link+'/'+nota.idhotlinesolicitacoes)
            // } else {
            //     this.$router.push('recepcao')
            // }
        },
        GetLinkSetor(idsetor) {
            // Percorrer os menus e submenus para encontrar a rota...
            var obj = this.$store.getters.GetRootItem
            var menu = {}
            if (obj && obj.objeto) {
                menu = JSON.parse(obj.objeto)
            }
            for (var i = 0; i < menu.children.length; i++) {
                var mi = menu.children[i]
                if (mi.idhotlinesetores == idsetor) {
                    return mi.link
                }
                if (mi.children) {
                    for (var j = 0; j < mi.children.length; j++){
                        var miChild = mi.children[j]
                        if (miChild.idhotlinesetores == idsetor) {
                            return miChild.link
                        }
                    }
                }
            }
            return null
        },
        connectSocket: function() {
            this.$socket.disconnect();
            
            this.$socket.io.opts.query.email = this.$store.getters.GetLoginInfo.email

            // Conectar a todos os setores a que o usuário tem acesso
            let setores = this.$store.getters.GetLoginInfo.setores;
            if (setores && Array.isArray(setores) && setores.length > 0) {
                let setoresStr = setores[0].idhotlinesetores;
                for (var i = 1; i < setores.length; i++) {
                    setoresStr += `,${setores[i].idhotlinesetores}`
                }
                this.$socket.io.opts.query.setores = setoresStr
            }
            
            this.$socket.connect();

            this.sockets.subscribe("NOTAUSUARIO", () => {
                this.loadNotificacoes()
            });

            this.sockets.subscribe("NOTASETOR", () => {
                this.loadNotificacoes()
            });

        } 

    },
    mounted() {
        this.connectSocket()
        setTimeout(()=>{ 
            this.loadNotificacoes() 
        },1000)
    },
    beforeDestroy(){
        this.sockets.unsubscribe("NOTAUSUARIO");
        this.sockets.unsubscribe("NOTASETOR");
        window.clearInterval(this.intervalId);
        // console.error(`Fim do Tick notificação: ${new Date()}`);
    },
    created() {
        this.intervalId = window.setInterval(() => {
            if (this.$store.getters.GetNotificacoes.length > 0
                && this.$route.path != '/painel/solicitacaodetalhe') {
                this.showDoc(false);
            }
            // console.error(`Tick notificação: ${new Date()}`);
        }, 5000);
    }

}
</script>

<style>
    .notification {
        color: white;
        text-decoration: none;
        position: relative;
        display: inline-block;
        border-radius: 10px;
        cursor: pointer;
        font-size: 13pt;
    }

    .notification .badge {
        font-size: 10pt!important;
        position: absolute;
        top: -1px!important;
        right: -6px;
        padding: 5px 4px!important;
        border-radius: 50%!important;
        background-color: #ff7a01;
        color: white;
    }

    @media only screen and (max-width: 991px) {
        .notification .badge {
            font-size: 8pt!important;
            top: -3px!important;
            right: -4px!important;
    }
    .avatar-container {
        cursor: pointer;
        position: relative;
    }
    /* .avatar-container .avatar-link {
        position: relative;
    } */
    .nav-link .avatar-initials {
        position: absolute;
        font-size: 0.95rem;
        color: #ff7a01;
        text-align: center;
        align-self: center;
        left: 25%;
        top: 25%;
    }

}
.es-scroll {
    overflow: scroll;
    height: 70vh;
    overflow-x: hidden;
}
.es-alerta {
    position: relative;
}
.es-dialog {
    display: none;
    position: fixed;
    width: 70%;
    height: 70vh;
    top: 15%;
    left: 15%;
    background-color: white;
    z-index: 1000;
    border: 3px solid rgb(45, 66, 107);
    border-radius: 0.7rem;
    padding: 10px;
}
.es-dialog-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
.es-sol-container {
    max-height: 400px;
    overflow-x: hidden;
    overflow-y: auto;    
}

.es-header {
    color: rgb(248, 222, 74);
    padding: 0.8rem;
    text-align: center;
    width: 100%;
    border-radius: 0.7rem;
    background-color: rgb(19, 64, 141);
    font-size: 1.2rem;
}
.es-carregando {
	padding: 3rem;
	padding-top: 7rem;
	padding-bottom: 7rem;
	color: orange;
	font-weight: bold;
}
.es-row {
    display: flex;
    flex-wrap: wrap;
    margin-top: 3px;
    margin-bottom: 3px;
    background-color: white;
    align-items: center;
    border-radius: 5px;
    padding: 0.3rem;
}
.es-table-header {
    width: 90%;
    padding: 0.8rem;
}
.es-table-content {
    width: 90%;
    overflow: scroll;
    height: 70vh;
    overflow-x: hidden;
}
.es-help {
    font-size: 50px;
    color: orange;
    cursor: pointer;
    padding: 0px;
    padding-top: 7px;
    border-radius: 50%;
}
.es-help:hover {
    color: #ff7a01;
    font-weight: bold;
}
</style>